import SihaUploadDocumentRequestModel from '../../../generated/types/model/request/SihaUploadDocumentRequestModel';

export default class SihaUploadDocumentRequestViewModel extends SihaUploadDocumentRequestModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
